import lrValueToLabel from './_src/lrValueToLabel.vue'
lrValueToLabel.install = function(Vue) {
  Vue.component(lrValueToLabel.name, lrValueToLabel)
}
export default lrValueToLabel